import { ALTERAR_EMPRESA_SELECIONADA } from '../types'
import { setEmpresaSelecionada } from '../../util/empresaSelecionada'

export default function alterarEmpresaSelecionada (empresaSelecionado) {
  setEmpresaSelecionada(empresaSelecionado)

  return {
    type: ALTERAR_EMPRESA_SELECIONADA,
    payload: empresaSelecionado
  }
}

export const alterouEmpresa = (props, prevProps) => prevProps.empresaSelecionada.id !== props.empresaSelecionada.id
